module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "main-fade"
    }
  }, [(_vm.ready) ? _c('img', {
    style: (_vm.css),
    attrs: {
      "src": _vm.src,
      "alt": _vm.alt
    },
    on: {
      "click": _vm.regImgInfo
    }
  }) : _c('loading', {
    attrs: {
      "setcss": _vm.css,
      "haveinfo": false,
      "size": _vm.size
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6e4e4e59!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/img/AppImg.vue
// module id = 183
// module chunks = 1